module.exports = __webpack_public_path__ + "static/img/summer_cheliziPic.d552cb24.png";